import styled from 'styled-components';

export const CardContainer = styled.div`
  background: white;
  border-radius: 5px;
  border: 1px solid #cccccc;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
  margin: 0px 20px 20px 20px;
`;

export const CardBody = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

export const CardTitle = styled.div`
  color: #003D50;
  font-family: Helvetica, "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: bold;
  padding: 30px 15px 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
`;

